// import loadable from '@loadable/component';

import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';
import ReactGA from 'react-ga4';
import { useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';
import Ripples from 'react-ripples';
import { matchPath, useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { isAuthenticated } from 'actions/user';
import ErrorBoundary from 'components/common/NullErrorBoundary';
import Tag from 'components/common/Tag';
import BellAlerts from 'components/Header/partials/BellAlerts';
import DepositButton from 'components/Header/partials/depositButton';
// import ThreeDotsMenu from 'components/primaryHeaderMobile/partials/mobileThreeDotsMenu';
import Render from 'components/render';
import {
  RenderByExchange,
  RenderForGlobalExchange,
  RenderForIndianExchange,
} from 'components/render/RenderByExchangeType';
import TransferFundModal from 'components/sub_account/trasnferFundModal';
import { IS_DEMO, IS_INDIAN_EXCHANGE } from 'constants/constants';
import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import { navigateTo } from 'helpers/url';
import { getLoggedUserType, getSubAccounts } from 'helpers/utils';
import useWalletIndianExchange from 'hooks/componentHooks/useWalletIndianExchange';
import useLanguageChange from 'hooks/useLanguageChange';
import useToggle from 'hooks/useToggle';
import i18n from 'i18n/config';
import { selectIsSubAccountHasSameEmail } from 'selectors/account';
import { userSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import {
  ArrowDownThin,
  DeltaIndiaLogoMobile,
  DeltaLogoMobile,
  DeltaLogoText,
} from 'styles/assets/icons';
import DeltaIndiaLogo from 'styles/assets/icons/DeltaIndiaLogo';
import PositionsHomeIcon from 'styles/assets/icons/PositionsHomeIcon';

import styles from './index.module.scss';
import AlgoMenuIndia from './partials/AlgoMenu/AlgoMenuIndia';
import MarginModeSelection from './partials/MarginModeSelection';
// import MobileAppTab from './partials/mobileAppTab';
import {
  DeltaGlobalDemoLogo,
  DeltaIndiaDemoLogo,
} from 'components/Header/Demo/DeltaIndiaDemoLogo';
import MobileAppTab from './partials/mobileAppTab';
import MoreMenuGlobal from './partials/MoreMenu/MoreMenuGlobal';
import MoreMenuIndian from './partials/MoreMenu/MoreMenuIndian';
import PrimarySideMenuGlobal from './partials/primarySideMenu/PrimarySideMenuGlobal';
import PrimarySideMenuIndia from './partials/primarySideMenu/PrimarySideMenuIndian';
import ProfileMenu from './partials/profileMenu';
import PreferencesSettingsMenu from './partials/settingsMenu';
import SignUpLoginTab from './partials/signUpLoginTab';
import UniversalSearch from './partials/universalSearch';
import WalletMenu from './partials/walletMenu';
import IndianExchangeWallet from './partials/walletMenu/indianExchange';

// For temp we are hiding this
// const PortfolioMarginBarIndianExchange = loadable(() =>
//   import(
//     /* webpackChunkName: "PortfolioMarginBarIndianExchange" */ './partials/portfolioMarginBarIndianExchange'
//   )
// );

const offersText = i18n.t('headerFooter:header.offers');
const transferFundTitleText = i18n.t('account:subAccount.transferFundTitle');
const addFundsText = i18n.t('headerFooter:header.wallet.addFunds');
const addBankText = i18n.t('headerFooter:header.wallet.addBank');
const marketsText = i18n.t('headerFooter:header.markets');
const futuresText = i18n.t('headerFooter:header.futures');
const optionsText = i18n.t('headerFooter:header.options');
const trackerText = i18n.t('headerFooter:header.tracker');
const reloadWalletText = i18n.t('headerFooter:header.reloadWallet');
const depositText = i18n.t('headerFooter:header.deposit');

const PrimaryHeader = () => {
  const history = useHistory();
  const isLoggedin = useSelector(state => isAuthenticated(state.user));
  const user = useSelector(state => userSelector(state));
  const { isBankAccountAdded } = user;
  const { accountValue } = useWalletIndianExchange();
  const isFundsAdded = Boolean(accountValue?.accountValueAmount ?? 0);
  const isSubAccountHasSameEmail = useAppSelector(selectIsSubAccountHasSameEmail);
  const [openTransferFundModal, toggleTransferFundModal] = useToggle(false);
  const loggedUserType = getLoggedUserType(user);
  // DO NOT DELETE BELOW
  const { activeLanguage, availableLocales, handleLanguageSwitch } = useLanguageChange();

  const onOfferTabClick = () => {
    trackMixpanelEvent('Offers - Header', { page_name: 'All Markets Page' });
    ReactGA.event({
      category: 'User',
      action: 'AM_offers_tag_clicked',
      value: user.id,
    });
    const url = `/offers`;
    navigateTo(url, '_blank');
  };

  // const onOptionsTabClick = () => {
  //   trackMixpanelEvent('Options - Header', { page_name: 'All Markets Page' });
  //   dispatch(changeContractType('options_chain'));
  //   history.push(routes.options_chain.trade);
  // };

  const onLanguageChange = locale => {
    trackMixpanelEvent('Language Changed - All Pages', {
      language_selected: locale,
    });
    handleLanguageSwitch(locale);
  };

  const onHeaderLinkClick = (link, mixpanelEvent) => {
    history.push(link);
    trackMixpanelEvent(mixpanelEvent, {
      page_name: 'All Markets Page',
    });
  };

  const { pathname } = history.location;
  const isDepositPage = Boolean(
    matchPath(pathname, {
      path: routes.account.deposit,
    })
  );
  const subAccounts = getSubAccounts(user, loggedUserType);

  const getTitle = () => {
    if (isSubAccountHasSameEmail) {
      return transferFundTitleText;
    }
    if (isBankAccountAdded || isFundsAdded) {
      return addFundsText;
    }
    return addBankText;
  };

  return (
    (<div
      className={styles[`primary-header`]}
      id="primary-header"
      data-palette="PrimaryHeader">
      <a
        data-testid="primary-header-logo-link"
        href={IS_DEMO? '/app' : `/`}
        className={styles.logo}
      >
        <MediaQuery query={device.down.lg}>
          <RenderForIndianExchange>
            <DeltaIndiaLogoMobile />
          </RenderForIndianExchange>
          <RenderForGlobalExchange>
            <DeltaLogoMobile />
          </RenderForGlobalExchange>
        </MediaQuery>
        <MediaQuery query={device.up.lg}>
          <RenderByExchange
            global={IS_DEMO? <DeltaGlobalDemoLogo /> : <DeltaLogoText />}
            indian={
              IS_DEMO? (
                <DeltaIndiaDemoLogo />
              ) : (
                <DeltaIndiaLogo className="headerLogoIndianExchange" />
              )
            }
          />
        </MediaQuery>
      </a>
      {/* <MediaQuery query={device.up.lg}>
        <Render when={!IS_DEMO}>
          <Ripples
            data-testid="buyCryptoLink-header"
            className={`${styles[`buy-crypto-link`]}  ${styles.overflowVisible}`}
            onClick={() => {
              history.push(routes.account.buy_crypto);
              trackMixpanelEvent('Buy Crypto Clicked', {
                source: 'Header',
                page_name: 'All Markets Page',
              });
            }}
            during={200}>
            {t('headerFooter:header.buyCrypto')}
          </Ripples>
        </Render>
      </MediaQuery> */}
      <Ripples
        data-testid="marketsLink-header"
        className={`${styles[`markets-link`]}  ${styles.overflowVisible}`}
        onClick={() => onHeaderLinkClick(routes.webAppHome, 'Markets- Header')}
        during={200}
      >
        {marketsText}
      </Ripples>
      <Ripples
        data-testid="marketsLink-header"
        className={`${styles[`markets-link`]}  ${styles.overflowVisible}`}
        onClick={() => onHeaderLinkClick(routes.futures.trade, 'Futures- Header')}
        during={200}
      >
        {futuresText}
      </Ripples>
      <Ripples
        data-testid="marketsLink-header"
        className={`${styles[`markets-link`]}  ${styles.overflowVisible}`}
        onClick={() => onHeaderLinkClick(routes.options_chain.trade, 'Options- Header')}
        during={200}
      >
        {optionsText}
      </Ripples>
      <RenderForIndianExchange>
        <Ripples
          data-testid="marketsLink-header"
          className={`${styles[`markets-link`]}  ${styles.overflowVisible}`}
          onClick={() => onHeaderLinkClick(routes.tracker.trade, 'Tracker- Header')}
          during={200}
        >
          {trackerText}
          <Tag text="New" className={styles[`new-tag`]} />
        </Ripples>

        {/* Algo Menu */}
        <AlgoMenuIndia />
      </RenderForIndianExchange>
      {/* Offers */}
      <Render when={!IS_DEMO}>
        <MediaQuery query={device.up.xl}>
          <Ripples
            data-testid="offerLink-header"
            className={styles['offers-tab']}
            onClick={onOfferTabClick}
          >
            <span className={styles[`offers-text`]}>{offersText}</span>
          </Ripples>
        </MediaQuery>
      </Render>
      {/* More Menu */}
      <RenderForGlobalExchange>
        <MoreMenuGlobal />
      </RenderForGlobalExchange>
      <Render when={IS_INDIAN_EXCHANGE && !IS_DEMO}>
        <MoreMenuIndian />
      </Render>
      {/* <Ripples
        className={styles['trade-farming-tab']}
        onClick={onTradeFarmingTabClick}>
        <span className={styles[`trade-farming-text`]}>
          {t('headerFooter:header.trade_farming')}{' '}
          <img
            src={TrophyIcon}
            alt="trophy"
            className={styles[`trophy-icon`]}
          />
        </span>
      </Ripples> */}
      <div className={styles.universalSearch}>
        <UniversalSearch />
      </div>
      {isLoggedin ? (
        <>
          <Render
            when={!IS_DEMO}
            else={
              <RenderForIndianExchange>
                <div className={styles['deposit-button']}>
                  <DepositButton
                    data-testid="header-deposit-button"
                    title={reloadWalletText}
                    className="header-deposit-btn"
                  />
                </div>
              </RenderForIndianExchange>
            }
          >
            <div className={styles['deposit-button']}>
              <Render
                when={IS_INDIAN_EXCHANGE}
                else={
                  <DepositButton
                    data-testid="header-deposit-button"
                    title={depositText}
                    className="header-deposit-btn"
                  />
                }
              >
                <Render when={!isDepositPage}>
                  <DepositButton
                    data-testid="header-deposit-button"
                    title={getTitle()}
                    shouldRedirectToAddBank={!isBankAccountAdded}
                    isSubAccountHasSameEmail={isSubAccountHasSameEmail}
                    toggleTransferFundModal={toggleTransferFundModal}
                    className="header-deposit-btn"
                  />
                </Render>
              </Render>
            </div>
          </Render>

          <MarginModeSelection />

          <div className={styles.wallet} data-palette="PrimaryHeader">
            <RenderByExchange global={<WalletMenu />} indian={<IndianExchangeWallet />} />
          </div>

          {/** for Temp hiding this for indian exchange */}
          {/* <RenderForIndianExchange>
            <div className={styles.portfolioMarginBarIndianExchange}>
              <PortfolioMarginBarIndianExchange />
            </div>
          </RenderForIndianExchange> */}

          <div className={styles.positions} data-palette="PrimaryHeader">
            <Link to="/account/positions">
              <PositionsHomeIcon className={styles.positionsIcon} />
            </Link>
          </div>
          <div className={styles.profile} data-palette="PrimaryHeader">
            <ProfileMenu />
          </div>
          {history.location.pathname !== '/bell_alerts' && (
            <ErrorBoundary>
              <div className={styles['header-notifs']}>
                <BellAlerts />
              </div>
            </ErrorBoundary>
          )}
          {/* <div className={styles['prefrences-settings']}>
            <PreferencesSettingsMenu />
          </div> */}
        </>
      ) : (
        <div
          className={styles['login-signup']}
          id="login-signup"
          data-palette="PrimaryHeader">
          <SignUpLoginTab />
        </div>
      )}
      {/*
       *  PLS KEEP IT ON HERE, BECAUSE WE HAVE  TO KEEP RESET TRADE LAYOUT FEATURE FOR LOGOUT USER
       *  XUEYING LI
       */}
      <div className={styles['prefrences-settings']}>
        <PreferencesSettingsMenu />
      </div>
      <Render when={!isLoggedin}>
        <div className={styles['phone-tab']}>
          <MobileAppTab />
        </div>
      </Render>
      {/* DO NOT DELETE BELOW */}
      {!isLoggedin && (
        <RenderForGlobalExchange>
          <div
            className={`dropdown-menu-container-parent ${styles.languages} ${styles.headerElement} d-lg-inline-block`}
          >
            <Menu
              menuButton={({ open }) => (
                <MenuButton
                  data-testid="active-language-button"
                  className={`${open ? styles.active : ''} ${styles.menuButton} p-0`}
                >
                  {activeLanguage}{' '}
                  <ArrowDownThin className={open ? `${styles.iconActive}` : ''} />{' '}
                </MenuButton>
              )}
              menuClassName={() =>
                `dropdown-menu-container language-dropdown-wrapper ${styles.languages} ${styles.menu}`
              }
            >
              {Object.keys(availableLocales).map(locale => (
                <MenuItem
                  data-testid={`languagesMenu-${locale}-option`}
                  key={locale}
                  onClick={() => onLanguageChange(locale)}
                  className={`dropdown-menu-item ${
                    activeLanguage === locale ? styles.active : ''
                  } ${styles.menuItem}`}
                >
                  <div data-locale={locale}>{locale}</div>

                  <div className={styles.dropdownLabel}>{availableLocales[locale]}</div>
                </MenuItem>
              ))}
            </Menu>
          </div>
        </RenderForGlobalExchange>
      )}
      <div className={styles['side-menu']}>
        <RenderByExchange
          indian={<PrimarySideMenuIndia />}
          global={<PrimarySideMenuGlobal />}
        />
      </div>
      <TransferFundModal
        isModalOpen={openTransferFundModal}
        handleCloseModal={toggleTransferFundModal}
        subAccounts={subAccounts}
        user={user}
      />
    </div>)
  );
};

export default PrimaryHeader;
